<template>
    <v-container fluid>
        <compensation-form
            :reward-completed="rewardCompleted"
            :reward-profile="rewardProfile"
            :reward-quota="rewardQuota"
            :revenue-completed="revenueCompleted"
            :revenue-profile="revenueProfile"
            :revenue-quota="revenueQuota"
            reward-help="edit-project-compensation-reward"
            revenue-help="edit-project-compensation-revenue"
            net-revenue-help="edit-project-compensation-net-revenue"
            warning-text="Revenue should be entered using reward points rather than any real currency.
                    For example if the CPI to your client is $3.52 and $1 = 100 points you would enter 352
                    as revenue."
            @change="valuesChanged"
            @error="handleErrors"
        ></compensation-form>
    </v-container>

</template>

<script>

    import CompensationForm from "../../../../../components/UI/CompensationForm";
    import TitleCard from "../../../../../components/UI/TitleCard";

    export default {

        components: {
            TitleCard,
            CompensationForm
        },

        props: {
            rewardCompleted: {
                type: Number | String,
                required: true,
            },
            rewardProfile: {
                type: Number | String,
                required: true,
            },
            rewardQuota: {
                type: Number | String,
                required: true,
            },
            revenueCompleted: {
                type: Number | String,
                required: true,
            },
            revenueProfile: {
                type: Number | String,
                required: true,
            },
            revenueQuota: {
                type: Number | String,
                required: true,
            },
        },

        methods: {
            handleErrors(error) {
                this.$emit('error', error);
            },

            valuesChanged(data) {
                this.$emit('change', data);
            }
        },
    }

</script>
